import { ApiCallState } from "../Utils";

export type MiscExpense = {
  id: number;
  date: string;
  description: string;
  expense_no: string;
  project_id: number;
  user_id: number;
  misc_expense_items: MiscExpenseItem[];
  misc_expense_checkeds: MiscExpenseChecked[];
  misc_expense_approveds: MiscExpenseApproved[];
  misc_expense_views: MiscExpenseView[];
  createdAt: any;
  updatedAt: any;
};

export type MiscExpenseItem = {
  id: number;
  misc_expense_id: number;
  description: string;
  quantity: number;
  rate: number;
  createdAt: any;
  updatedAt: any;
};

export type MiscExpenseChecked = {
  id: number;
  misc_expense_id: number;
  user_id: number;
  sender_id: number;
  is_checked: boolean;
  is_revised: boolean;
  createdAt: any;
  updatedAt: any;
};

export type MiscExpenseApproved = {
  id: number;
  misc_expense_id: number;
  user_id: number;
  sender_id: number;
  is_approved: boolean;
  is_revised: boolean;
  createdAt: any;
  updatedAt: any;
};

export type MiscExpenseView = {
  id: number;
  misc_expense_id: number;
  user_id: number;
  sender_id: number;
  createdAt: any;
  updatedAt: any;
};

export type MiscExpenseStateTypes = {
  fetchAll: ApiCallState<MiscExpense[]>;
  fetchOne: ApiCallState<MiscExpense | {}>;
};

export const MiscExpenseActionTypes = {
  FETCH_ALL_MISC_EXPENSE: "FETCH_ALL_MISC_EXPENSE",
  FETCH_ALL_MISC_EXPENSE_RESET: "FETCH_ALL_MISC_EXPENSE_RESET",
  FETCH_ALL_MISC_EXPENSE_FAILURE: "FETCH_ALL_MISC_EXPENSE_FAILURE",
  FETCH_ALL_MISC_EXPENSE_SUCCESS: "FETCH_ALL_MISC_EXPENSE_SUCCESS",

  FETCH_ONE_MISC_EXPENSE: "FETCH_ONE_MISC_EXPENSE",
  FETCH_ONE_MISC_EXPENSE_RESET: "FETCH_ONE_MISC_EXPENSE_RESET",
  FETCH_ONE_MISC_EXPENSE_FAILURE: "FETCH_ONE_MISC_EXPENSE_FAILURE",
  FETCH_ONE_MISC_EXPENSE_SUCCESS: "FETCH_ONE_MISC_EXPENSE_SUCCESS",
};
